
import { Component, Vue, Watch } from 'vue-property-decorator';

import { sharedState } from '../../../../../framework/state';
import { getEnumerationOptions, getOptionLabel } from '../../../../../framework/service/options';

import { VendorContractType } from '../../../../../../common/application/model/enums/VendorContractType';
import { Customer } from '../../../../../../common/application/model/Customer';
import { ApplicationResource } from '../../../../../../common/application/enumeration/ApplicationResource';
import { VendorContractByTypeResult } from '../../../../../../common/application/model/VendorContractByTypeResult';

import { getCustomerOptions, getVendorOptions } from '../../../../service/application_options_service';
import { getVendorContractsByType, getVendorContractsByTypePaging } from '../../../../client/vendor_contract_client';

import AutoCompleteMultipleField from '../../../../fields/AutoCompleteMultipleField.vue';

import ParameterService from '../../../../service/parameter_service';

@Component({
    components: { AutoCompleteMultipleField },
})
export default class CustomerVendorContracts extends Vue {
    readonly resourceType = ApplicationResource.CUSTOMER_VENDOR_CONTRACT;
    parameterService = new ParameterService(this.resourceType);

    shared = sharedState;
    local = {
        rows: [] as VendorContractByTypeResult[],
        customer: undefined as Customer | undefined,
        total: 0,
        loading: false,
        defaultSortOrder: 'asc',
        selected: undefined as VendorContractByTypeResult | undefined,
        customerOptions: [] as { id: string | undefined; label: string }[],
        vendorOptions: [] as { id: string | undefined; label: string }[],
        vendorContractTypeOptions: [] as { id: string | undefined; label: string }[],
        parameters: this.parameterService.get(),
    };

    async mounted() {
        if (this.$route.params && this.$route.params.customerId) {
            this.local.parameters.customerId = this.$route.params.customerId.split(',');
            this.parameterService.set(this.local.parameters);
        }

        this.local.customerOptions = await getCustomerOptions();
        this.local.vendorOptions = await getVendorOptions();
        this.local.vendorContractTypeOptions = getEnumerationOptions(
            'VendorContractType',
            Object.keys(VendorContractType),
            this,
        );

        await this.loadAsyncData();
    }

    dropdownClosed(resourceIds: string[], idField: string): void {
        if (this.local.loading) {
            return;
        }

        if (!resourceIds.length) {
            delete this.local.parameters[idField];
        } else {
            this.local.parameters[idField] = resourceIds;
        }

        this.resetPagingAndLoadData();
    }

    @Watch('local.parameters.vendorId')
    async vendorIdChange() {
        if (this.local.loading) {
            return;
        }

        await this.resetPagingAndLoadData();
    }

    @Watch('local.parameters.vendorContractType')
    async vehicleContractIdIdChange() {
        if (this.local.loading) {
            return;
        }

        await this.resetPagingAndLoadData();
    }

    getVendorContractType(id: string): string {
        return getOptionLabel(id, this.local.vendorContractTypeOptions);
    }

    add() {
        this.$router.push({ path: `/${ApplicationResource.VENDOR_CONTRACT}/add` });
    }

    onRowClick(row: VendorContractByTypeResult) {
        if (this.local.selected && row.vendorId === this.local.selected.vendorId) {
            this.local.selected = undefined;
        }
    }

    goToInvoices(vendorId: string) {
        this.$router.push({
            name: 'vendor-invoices',
            params: {
                customerId: this.local.parameters.customerId.join(','),
                vendorId,
            },
        });
    }

    async resetFilter(): Promise<void> {
        this.local.parameters = this.parameterService.getDefault();
        await this.resetPagingAndLoadData();
    }

    get isAdmin(): boolean {
        return this.shared.admin;
    }

    customerParameters(): Map<string, string> {
        // return new Map<string, string>([['customerState', 'active']]);
        return new Map<string, string>();
    }

    customerSelected(): boolean {
        return !(!this.local.parameters.customerId || !this.local.parameters.customerId.length);
    }

    private async loadAsyncData() {
        this.local.loading = true;

        const backendParameters = this.parameterService.getBackendParameters();

        this.local.rows = [];

        if (!this.local.parameters.customerId) {
            this.local.loading = false;
            return;
        }

        this.local.rows = (await getVendorContractsByType(backendParameters)) as VendorContractByTypeResult[];
        this.local.total = this.local.rows.length;

        if (this.local && this.local.rows.indexOf(this.local.selected!!) == -1) {
            this.local.selected = undefined;
        }

        this.local.loading = false;
    }

    private async resetPagingAndLoadData() {
        this.local.parameters.page = 1;
        this.parameterService.set(this.local.parameters);
        await this.loadAsyncData();

        this.$forceUpdate();
    }
}
